import React, { useState, useEffect } from "react";
import { Paper, Typography } from "@material-ui/core";
import { useStyles } from "./classes";
import * as api from "../../api/index.js";
import FavoriteMenuCard from "./FavoriteMenuCard";

const FavoriteMenus = () => {
  const classes = useStyles();
  const [data, setData] = useState([]);

  useEffect(() => {
    (async () => {
      const { data } = await api.userFavMenu();
      setData(data);
    })();
  }, []);

  return (
    <>
      <Typography className={classes.menuInfo}>Favorite Menus</Typography>

      <Paper className={classes.menus}>
        <div
          style={{
            display: "flex",
            flexDirection: "row",
            flexWrap: "wrap",
            justifyContent: "flex-start",
            alignContent: "flex-start",
            alignItems: "space-between",
          }}
        >
          {data.map((res, idx) => (
            <FavoriteMenuCard res={res} idx={idx} />
          ))}
        </div>
      </Paper>
    </>
  );
};

export default FavoriteMenus;
